// Construct the THREE renderer/camera/scene stack + OrbitControls + clock,
// mount the canvas. Pure scene-host setup; no domain logic.

import * as THREE from 'three';
import { mountCanvas } from '@ui/dom';
import { params } from '@store/instance';
import { buildDefaultCamera, createControls, loadProjection } from '../cameraProjection';
import type { ViewerContext } from '../context';

export function createThreeStack(viewer: ViewerContext): void {
    viewer.three.scene = new THREE.Scene();
    viewer.three.scene.background = new THREE.Color(0x000022);

    const renderer = viewer.three.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.localClippingEnabled = true;
    renderer.sortObjects = true;
    mountCanvas(renderer);

    // Boot in the persisted projection (defaults to perspective).
    const projection = loadProjection();
    params.cameraProjection = projection;
    viewer.three.camera = buildDefaultCamera(projection);
    viewer.three.controls = createControls(viewer, viewer.three.camera);

    viewer.three.clock = new THREE.Clock();
}
